import { createAsyncThunk } from '@reduxjs/toolkit';
import { apiClient } from '../../utils/apiClient';
import { API_USERS_ME_PERMISSIONS } from '../../constants/apiConstants';

interface MePermissionsEnvelope {
  data: { permissions?: string[]; roles?: string[] } | null;
  succeeded: boolean;
  messages?: string[];
}

/**
 * Loads the caller's tenant-effective permission codes for one workspace —
 * `GET /me/permissions?tenantId=` resolves the Phase-2 union (global roles ∪
 * the user's role for THAT tenant) on the backend, tenant-keyed cache included.
 * Spec: edi-role-user-counts-and-admin-assignment (D3).
 */
export const fetchWorkspacePermissions = createAsyncThunk<
  { tenantId: number; permissions: string[] },
  { tenantId: number }
>('workspacePermissions/fetch', async (arg, { rejectWithValue }) => {
  try {
    const response = await apiClient.get<MePermissionsEnvelope>(API_USERS_ME_PERMISSIONS, {
      params: { tenantId: arg.tenantId },
    });
    if (!response.data.succeeded) {
      return rejectWithValue(response.data.messages?.join(', ') || 'Failed to load workspace permissions');
    }
    return { tenantId: arg.tenantId, permissions: response.data.data?.permissions ?? [] };
  } catch (error: unknown) {
    return rejectWithValue(error instanceof Error ? error.message : 'Failed to load workspace permissions');
  }
});
